var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnSupportListLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5154_112935)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.33333,
    stroke: "white",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 12,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.76172 10.1436C7.52474 10.1436 7.34473 10.0684 7.22168 9.91797C7.10319 9.76302 7.04395 9.57161 7.04395 9.34375V9.18652C7.04395 8.8903 7.08952 8.62598 7.18066 8.39355C7.27637 8.16113 7.4222 7.94922 7.61816 7.75781C7.81413 7.56185 8.06022 7.375 8.35645 7.19727C8.62988 7.02865 8.84863 6.86686 9.0127 6.71191C9.17676 6.55697 9.29297 6.3929 9.36133 6.21973C9.43424 6.04199 9.4707 5.84147 9.4707 5.61816C9.4707 5.34928 9.4069 5.11458 9.2793 4.91406C9.15169 4.70898 8.97396 4.54948 8.74609 4.43555C8.51823 4.32161 8.25163 4.26465 7.94629 4.26465C7.53613 4.26465 7.19661 4.36491 6.92773 4.56543C6.65885 4.76139 6.46973 5.04395 6.36035 5.41309C6.28743 5.62728 6.19629 5.77767 6.08691 5.86426C5.9821 5.94629 5.84082 5.9873 5.66309 5.9873C5.45345 5.9873 5.28939 5.92806 5.1709 5.80957C5.05697 5.69108 5 5.52702 5 5.31738C5 5.17155 5.01595 5.03483 5.04785 4.90723C5.07975 4.77962 5.12533 4.64974 5.18457 4.51758C5.39421 4.04362 5.74512 3.6722 6.2373 3.40332C6.73405 3.13444 7.3265 3 8.01465 3C8.6071 3 9.13118 3.10938 9.58691 3.32812C10.0426 3.54232 10.3981 3.8431 10.6533 4.23047C10.9085 4.61328 11.0361 5.05534 11.0361 5.55664C11.0361 6.08529 10.9085 6.53874 10.6533 6.91699C10.4027 7.29069 10.0518 7.61198 9.60059 7.88086C9.30892 8.05404 9.08105 8.21582 8.91699 8.36621C8.75293 8.51204 8.63672 8.66927 8.56836 8.83789C8.5 9.00195 8.46126 9.19336 8.45215 9.41211C8.43392 9.63542 8.37012 9.81315 8.26074 9.94531C8.15592 10.0775 7.98958 10.1436 7.76172 10.1436Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5154_112935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnSupportListLight);
export default __webpack_public_path__ + "static/media/icn_support_list_light.68aeaae9557b4f6655d4bd6dcce35960.svg";
export { ForwardRef as ReactComponent };